import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id", "required"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  class: "block mb-2 text-sm font-medium",
  style: {"color":"#374151"}
}
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "flex flex-col items-center gap-1.5 pointer-events-none" }
const _hoisted_6 = {
  class: "w-7 h-7 transition-colors group-hover:text-[#6CC551]",
  style: {"color":"#d1d5db"},
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-xs font-semibold transition-colors group-hover:text-[#6CC551]",
  style: {"color":"#6b7280"}
}, "Click to upload", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-[10px]",
  style: {"color":"#6b7280"}
}, "Any supported file format", -1)
const _hoisted_11 = ["id", "required"]
const _hoisted_12 = ["for"]
const _hoisted_13 = {
  key: 0,
  class: "ml-0.5",
  style: {"color":"#ef4444"}
}
const _hoisted_14 = ["type", "id", "placeholder", "required", "value"]


const __default__ = {
  inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InputField',
  props: {
    label: null,
    id: null,
    type: null,
    placeholder: null,
    isRequired: { type: Boolean },
    modelValue: null,
    className: null
  },
  emits: ['update:modelValue'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.type === 'checkbox')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex items-start gap-3", __props.className])
        }, [
          _createElementVNode("input", _mergeProps(_ctx.$attrs, {
            id: __props.id,
            type: "checkbox",
            class: "mt-0.5 w-4 h-4 rounded cursor-pointer accent-[#6CC551]",
            style: {"border-color":"#d1d5db"},
            required: __props.isRequired
          }), null, 16, _hoisted_1),
          _createElementVNode("label", {
            for: __props.id,
            class: "text-xs font-medium leading-relaxed cursor-pointer",
            style: {"color":"#374151"}
          }, _toDisplayString(__props.label), 9, _hoisted_2)
        ], 2))
      : (__props.type === 'file')
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["text-left", __props.className])
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.label), 1),
            _createElementVNode("label", {
              for: __props.id,
              class: "flex flex-col items-center justify-center w-full h-28 rounded-lg cursor-pointer transition-colors group",
              style: {"border":"2px dashed #e5e7eb"}
            }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8)),
                _hoisted_9,
                _hoisted_10
              ]),
              _createElementVNode("input", _mergeProps(_ctx.$attrs, {
                id: __props.id,
                type: "file",
                class: "hidden",
                required: __props.isRequired
              }), null, 16, _hoisted_11)
            ], 8, _hoisted_4)
          ], 2))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["text-left", __props.className])
          }, [
            _createElementVNode("label", {
              for: __props.id,
              class: "block mb-2 text-sm font-medium",
              style: {"color":"#374151"}
            }, [
              _createTextVNode(_toDisplayString(__props.label), 1),
              (__props.isRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_12),
            _createElementVNode("input", _mergeProps(_ctx.$attrs, {
              type: __props.type,
              id: __props.id,
              class: "w-full px-4 py-2 text-sm rounded-lg focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors",
              style: {"background":"#fff","border":"1px solid #e5e7eb","color":"#111827"},
              placeholder: __props.placeholder,
              required: __props.isRequired,
              value: __props.modelValue,
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as HTMLInputElement).value)))
            }), null, 16, _hoisted_14)
          ], 2))
  ]))
}
}

})